module.exports = __webpack_public_path__ + "img/79.fda3cd03.png";